__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "crediconvenio-Container";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/common", "15.1.0", () => (__webpack_require__.e("node_modules_angular_common_fesm2020_common_mjs-_ec490").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/common/fesm2020/common.mjs */ 94666))))));
			register("@angular/core", "15.1.0", () => (__webpack_require__.e("node_modules_angular_core_fesm2020_core_mjs").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/core/fesm2020/core.mjs */ 22560))))));
			register("@angular/router", "15.1.0", () => (__webpack_require__.e("node_modules_angular_router_fesm2020_router_mjs-_6f001").then(() => (() => (__webpack_require__(/*! ./node_modules/@angular/router/fesm2020/router.mjs */ 60124))))));
			register("@npm-bbta/bbog-dig-dt-webcomponents-lib/loader", "5.3.1", () => (__webpack_require__.e("node_modules_npm-bbta_bbog-dig-dt-webcomponents-lib_loader_index_es2017_js-_0eb21").then(() => (() => (__webpack_require__(/*! ./node_modules/@npm-bbta/bbog-dig-dt-webcomponents-lib/loader/index.es2017.js */ 34147))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};